export interface DemoWhoopDayData {
  id: string;
  date: string;
  recovery_score: number;
  hrv_score: number;
  resting_heart_rate: number;
  sleep_performance: number;
  sleep_duration_minutes: number;
  sleep_quality_score: number;
  strain_score: number;
  calories_burned: number;
  raw_data: {
    source: 'therappi_demo';
    recovery_note: string;
    sleep_note: string;
  };
}

const toDateString = (date: Date) => date.toISOString().slice(0, 10);

const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export function generateWhoopDemoData(days = 90): DemoWhoopDayData[] {
  const today = new Date();

  return Array.from({ length: days }, (_, index) => {
    const date = new Date(today);
    date.setDate(today.getDate() - index);

    const weeklyWave = Math.sin(index / 4.6);
    const longerWave = Math.cos(index / 11.5);
    const recoveryTrend = (days - index) * 0.11;
    const sleepWave = Math.sin(index / 5.8 + 1.4);
    const strainWave = Math.cos(index / 3.7);

    const recovery = Math.round(clamp(64 + recoveryTrend + weeklyWave * 13 + longerWave * 5, 42, 95));
    const hrv = Math.round(clamp(43 + recoveryTrend * 0.65 + weeklyWave * 7 + longerWave * 3, 31, 78));
    const restingHeartRate = Math.round(clamp(62 - recoveryTrend * 0.11 - weeklyWave * 2.4 + longerWave * 1.5, 51, 68));
    const sleepPerformance = Math.round(clamp(78 + sleepWave * 10 + recoveryTrend * 0.18, 58, 96));
    const sleepDuration = Math.round(clamp(430 + sleepWave * 48 + recoveryTrend * 1.2, 345, 540));
    const strain = Number(clamp(11.2 + strainWave * 3.1 + (index % 6 === 0 ? 2.4 : 0), 6.4, 18.8).toFixed(1));
    const calories = Math.round(clamp(2050 + strain * 74 + Math.sin(index / 2.9) * 160, 1900, 3550));

    return {
      id: `therappi-whoop-demo-${toDateString(date)}`,
      date: toDateString(date),
      recovery_score: recovery,
      hrv_score: hrv,
      resting_heart_rate: restingHeartRate,
      sleep_performance: sleepPerformance,
      sleep_duration_minutes: sleepDuration,
      sleep_quality_score: sleepPerformance,
      strain_score: strain,
      calories_burned: calories,
      raw_data: {
        source: 'therappi_demo',
        recovery_note: recovery >= 67 ? 'Strong readiness pattern' : 'Moderate readiness pattern',
        sleep_note: sleepPerformance >= 85 ? 'Restorative sleep window' : 'Usable sleep baseline',
      },
    };
  });
}